export const TIMING = Object.freeze({
  UI: {
    START_UI_REVEAL: 1500,
    BLACKOUT_TIMER: 200,
    BLACKOUT_WAIT_TO_REVEAL: 50,
  },
  VIDEO: {
    VID_END_TIMER: 1500,
  },
});
export const ASSETS = Object.freeze({
  "view-1": {
    desktop:
      "https://cdn.prod.website-files.com/61e77b1e3ddfc76b6fe81446/69dc14060009e236c0c0f119_Components-View-A.webp",
    mobile:
      "https://cdn.prod.website-files.com/61e77b1e3ddfc76b6fe81446/69dc140698d66fcc5992f6a1_Components-View-A-Mobile-P.webp",
  },
  "view-2": {
    desktop:
      "https://cdn.prod.website-files.com/61e77b1e3ddfc76b6fe81446/69dc140642f49cf016b02faf_Components-View-B.webp",
    mobile:
      "https://cdn.prod.website-files.com/61e77b1e3ddfc76b6fe81446/69dc14063b5a21520e44a7b9_Components-View-B-Mobile-P.webp",
  },
});
export const VIEW_START_END = Object.freeze({
  "view-1": {
    startTime: 0,
    endTime: 3.2,
  },
  "view-2": {
    startTime: 3.64,
    endTime: 6.9,
  },
});
export const LOOP_SEQUENCE_VIDS = true;
